// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Ima-z","updatedSizingPrediction":"Jma-z","recommendedSize":"Kma-z","predictedSize":"Lma-z","recommendedSizeCopy":"Mma-z"};